<template>
  <v-container>
    <v-form autocomplete="off">
      <v-list-item>
        <v-list-item-content>
          <div class="d-flex justify-space-between">
            <Label
              class="flex-grow-1 mr-5"
              label="姓"
              :editable="editable"
              required
            >
              <InputText
                name="name_sei"
                :autofocus="autofocus"
                :values="formValues"
                :editable="editable"
                placeholder="山田"
                validation_label="姓"
                validation_rules="required|max:64"
                @onInput="onInput"
              />
            </Label>
            <Label
              class="flex-grow-1 ml-5"
              label="名"
              :editable="editable"
              required
            >
              <InputText
                name="name_mei"
                :values="formValues"
                :editable="editable"
                placeholder="太郎"
                validation_label="名"
                validation_rules="required|max:64"
                @onInput="onInput"
              />
            </Label>
          </div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <div class="d-flex justify-space-between">
            <Label
              class="flex-grow-1 mr-5"
              label="セイ"
              :editable="editable"
              required
            >
              <InputText
                name="kana_sei"
                :values="formValues"
                :editable="editable"
                placeholder="ヤマダ"
                validation_label="セイ"
                validation_rules="required|max:128|kana"
                @onInput="onInput"
              />
            </Label>
            <Label
              class="flex-grow-1 ml-5"
              label="メイ"
              :editable="editable"
              required
            >
              <InputText
                name="kana_mei"
                :values="formValues"
                :editable="editable"
                placeholder="タロウ"
                validation_label="メイ"
                validation_rules="required|max:128|kana"
                @onInput="onInput"
              />
            </Label>
          </div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <Label label="所属会社" :editable="editable" required>
            <SelectWithFilter
              pinId="selectUserFormPage1"
              name="company_id"
              :values="formValues"
              :items="companyList"
              :editable="editable && !disableSelectCompany"
              validation_label="所属会社"
              validation_rules="required"
              :isChangeMessage="true"
              noDataText="会社の登録がありません"
              @onInput="onInput"
              @handleAction="isShowRegisterCompany = true"
            ></SelectWithFilter>
          </Label>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <Label label="管理者フラグ" :editable="editable">
          <SwitchInput
            name="role"
            label="管理者"
            :values="formValues"
            :editable="editable && !isAdminFlag"
            @onInput="onInput"
          />
          <span class="caution">
            ※「点検者」アカウントは各ユーザーで登録してください。
          </span>
        </Label>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <Label label="メールアドレス" :editable="editable" required>
            <div class="d-flex">
              <InputText
                class="flex-grow-1"
                name="email"
                :values="formValues"
                :editable="editable && !isAdminFlag"
                placeholder="example@example.com"
                validation_label="メールアドレス"
                validation_rules="max:255|alphanumericHalfSize|email|required"
                @onInput="onInput"
                @onChanged="$emit('onChanged')"
              />
              <v-icon v-if="!isEmailValid" class="circle-icon"
                >mdi-close</v-icon
              >
            </div>
          </Label>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content v-if="!isNewItem">
          <Label label="アサイン現場">
            <v-list style="max-height: 300px; overflow-y: auto">
              <v-list-item
                style="min-height: 0 !important"
                v-for="item in listField"
                :key="item.id"
              >
                <v-list-item-content style="padding: 0 !important">
                  <v-list-item-title class="d-flex align-center">
                    <v-icon
                      small
                      class="mr-2"
                      :color="item.end_use_flg == null ? 'success' : 'error'"
                    >
                      {{ item.end_use_flg == null ? "mdi-check" : "mdi-close" }}
                    </v-icon>
                    <div :class="{ 'disabled-text': !editable }">
                      {{ item.name }}
                    </div>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </Label>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="isShowQA">
        <v-list-item-content>
          <Label label="合言葉 ※パスワード再設定時に使用します"></Label>
          <div class="d-flex justify-space-between">
            <Label
              class="flex-grow-1 mr-5"
              label="質問"
              :editable="editable"
              required
            >
              <InputText
                name="question"
                :values="formValues"
                validation_label="質問"
                :editable="editable"
                validation_rules="required|max:255"
                placeholder="らくらく"
                @onInput="onInput"
              />
            </Label>
            <Label
              class="flex-grow-1 ml-5"
              label="回答"
              :editable="editable"
              required
            >
              <InputText
                name="answer"
                :values="formValues"
                :editable="editable"
                validation_label="回答"
                validation_rules="required|max:255"
                placeholder="点検"
                @onInput="onInput"
              />
            </Label>
          </div>
        </v-list-item-content>
      </v-list-item>
      <Popup :dialog="isShowRegisterCompany">
        <CompanyForm
          :isNewItem="true"
          @cancel="isShowRegisterCompany = false"
          @updateCompany="getListCompanies"
        />
      </Popup> </v-form
  ></v-container>
</template>
<script>
import Label from "../elements/Label";
import InputText from "../elements/InputText";
import SelectWithFilter from "../elements/SelectWithFilter.vue";
import SwitchInput from "@/components/forms/elements/SwitchInput";
import CompanyForm from "@/components/forms/company/index";
import Popup from "@/components/common/Popup.vue";
import { Store } from "@/store/Store.js";
import { COMPANY_TYPE } from "@/constants/COMMON";

export default {
  data: () => {
    return {
      isShowRegisterCompany: false,
      isCompanyChanged: false,
      formValues: {},
      companyList: [],
      listField: [],
      autofocus: false,
    };
  },
  components: {
    Label,
    InputText,
    SelectWithFilter,
    SwitchInput,
    CompanyForm,
    Popup,
  },
  props: {
    item: Object,
    editable: {
      type: Boolean,
      default: false,
    },
    isEmailValid: {
      type: Boolean,
      default: false,
    },
    formUpdate: Function,
    isNewItem: Boolean,
  },
  mounted() {
    this.getListCompanies();
    this.$watch(
      () => this.item,
      async (newValue) => {
        if (!newValue) return;

        let formValues = { ...newValue };

        if (
          this.isNewItem &&
          this.loginUser.company_type !== COMPANY_TYPE.ADMIN &&
          !this.isCompanyChanged
        ) {
          formValues.company_id = this.loginUser.company_id;
        }

        this.formValues = formValues;

        if (!this.isNewItem && formValues?.id) {
          await this.getListFieldInfoByUserId();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );
    this.$watch(
      () => this.editable,
      (newValue) => {
        this.autofocus = newValue;
        if (newValue && !this.isNewItem) {
          const textFieldFirst = document.getElementsByTagName("input");
          textFieldFirst[9].focus();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );
    this.$watch(
      () => Store.getters[`Company/getData`],
      (data) => {
        this.companyList = [...data];
        this.companyList.unshift({
          id: null,
          name: "",
        });
      },
      {
        immediate: true,
        deep: true,
      }
    );
  },
  computed: {
    loginUser() {
      return Store.state.Login.user;
    },
    companyType() {
      return this.loginUser?.company_type;
    },
    apiParams() {
      return {
        only_owner: this.companyType == COMPANY_TYPE.OWNER ? 1 : null,
      };
    },
    disableSelectCompany() {
      switch (this.companyType) {
        case COMPANY_TYPE.PARTNER:
        case COMPANY_TYPE.RENTAL:
          return true;
        case COMPANY_TYPE.OWNER:
        case COMPANY_TYPE.ADMIN:
          return false;
        default:
          return false;
      }
    },
    isAdminFlag() {
      return this.formValues["admin_user_flg"] === 1;
    },
    isShowQA() {
      return (
        this.isNewItem ||
        this.loginUser.company_type === 9 ||
        this.formValues.id == this.loginUser.id
      );
    },
  },
  methods: {
    async getListCompanies(params) {
      await Store.dispatch("Company/get", this.apiParams);
      if (params) {
        this.isCompanyChanged = true;
        this.formValues["company_id"] = params;
      }
    },
    async getListFieldInfoByUserId() {
      let apiParams = {
        user_id: this.formValues.id,
      };
      const response = await Store.dispatch(
        `Users/getListFieldInfoByUserId`,
        apiParams
      );
      if (!response.hasError) {
        const { entries } = response.data.contents;
        this.listField = entries;
      }
    },
    onInput({ name, value }) {
      const formValues = { ...this.formValues };
      formValues[name] = value;
      if (name == "company_id") {
        this.isCompanyChanged = true;
      }
      this.formValues = formValues;
      this.$emit("formUpdate", formValues);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/themes.scss";

.circle-icon {
  width: 30px;
  height: 30px;
  margin: 5px 0 0 5px;
  background-color: $warning_color;
  border-radius: 50%;
  color: black !important;
}
.caution {
  color: $warning_color;
  font-size: 14px;
}
.disabled-text {
  color: rgba(0, 0, 0, 0.38);
  pointer-events: none;
}
</style>
